//@ts-nocheck
import React, { useState, useRef, useEffect } from "react";
import SVGFactory, { SVGName } from "../../svgFactory";
import "./UserDetails.css";
import { useHistory, useLocation } from "react-router-dom";
import { claimRewardSTW } from "../../apis";
import Background from "../../SlotMachine/components/Background/Background";
import Button from "../../SlotMachine/components/Button/Button";
import Header from "../../SlotMachine/components/Header/Header";
import PoweredByBik from "../../SlotMachine/components/PowereByBik/PoweredByBik";
import Title from "../../SlotMachine/components/Title/Title";
import ReCAPTCHA from "react-google-recaptcha";
import GameRules from "../../GameRules";

let captchaId = null;
const UserDetails = () => {
  const recaptchaRef = useRef<ReCAPTCHA>();
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [showGameRules, setShowGameRules] = useState<boolean>(false);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-666593854/j5cbCOa12ZMYEL7U7b0C",
      });
    }
  }, []);

  const onInputChangeHandle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError("");
    setPhoneNumber(e.target.value);
  };

  const claimRewardHandle = async () => {
    if (showLoader) {
      return;
    }
    if (!recaptchaRef.current) {
      return;
    }
    if (!phoneNumber || phoneNumber?.length !== 10) {
      setError("Please enter a valid phone number");
    } else {
      setShowLoader(true);
      const recaptchaValue = await recaptchaRef.current.executeAsync();
      if (recaptchaValue) {
        captchaId = recaptchaValue;
      }
      const response: any = await claimRewardSTW(
        phoneNumber,
        location.state.couponId as unknown as string,
        captchaId,
        location.state.utm
      );
      if (response.status === 200) {
        redirectToFinalPage(response.data);
      } else {
        setError(response.error ? response.error : "Something went wrong");
      }
      setShowLoader(false);
      recaptchaRef.current.reset();
    }
  };

  const redirectToFinalPage = (couponDetails) => {
    history.push({
      pathname: "/shoppers-stop/couponDetails",
      state: {
        couponCode: couponDetails.couponCode,
        description: couponDetails.description,
      },
    });
  };
  const onUpadteShowGameRulesState = (flag: boolean) => {
    setShowGameRules(flag)
  }
  return (
    <>
      <Background>
        <Header />
        <div className="bik-sm-details-main-conatiner">
          <SVGFactory name={SVGName.CONFETTI_VALENTINE} />
          <Title
            title="Congratulations"
            subTitle1="You're a winner! Please enter your number and claim the offer"
            titleContainerStyle={{ marginBottom: 0 }}
          />
          <div className="bik-sm-input-container">
            <span>Phone Number</span>
            <input
              type="number"
              placeholder="Enter your registered number"
              onChange={(e) => onInputChangeHandle(e)}
              value={phoneNumber}
            />
          </div>
          <div className="bik-btn-container">
            <Button
              buttonText="Claim the offer"
              backgroundColor="#2E2F7D"
              color="#fff"
              showLoader={showLoader}
              onClickHandle={claimRewardHandle}
            />
            {error.length ? <p>{error}</p> : <></>}
          </div>
        </div>
        <PoweredByBik onTandCClickHandle={onUpadteShowGameRulesState} />
        {showGameRules && <GameRules onCloseHandle={onUpadteShowGameRulesState} />}
      </Background>
      <ReCAPTCHA
        size="invisible"
        ref={recaptchaRef}
        sitekey={process.env.REACT_APP_RECAPTCHA_SECRET_KEY}
        onChange={() => { }}
      />
    </>
  );
};

export default UserDetails;
